/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@progress/kendo-angular-popup/dist/es/popup.component';
import * as i2 from '@angular/common';
import * as i3 from '@progress/kendo-angular-popup/dist/es/services/dom.service';
import * as i4 from '@progress/kendo-angular-popup/dist/es/services/align.service';
import * as i5 from '@progress/kendo-angular-popup/dist/es/services/position.service';
import * as i6 from '@progress/kendo-angular-popup/dist/es/services/resize.service';
import * as i7 from '@progress/kendo-angular-popup/dist/es/services/scrollable.service';
const styles_PopupComponent:any[] = ([] as any[]);
export const RenderType_PopupComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_PopupComponent,data:{'animation':[{type:7,name:'toggle',definitions:[{type:1,
        expr:'void => down, up => down',animation:[{type:6,styles:{transform:'translateY(-100%)'},
            offset:(null as any)},{type:4,styles:{type:6,styles:{transform:'translateY(0)'},
            offset:(null as any)},timings:'0.1s ease-in'}],options:(null as any)},
        {type:1,expr:'down => void',animation:[{type:6,styles:{transform:'translateY(0)'},
            offset:(null as any)},{type:4,styles:{type:6,styles:{transform:'translateY(-100%)'},
            offset:(null as any)},timings:'0.1s ease-in'}],options:(null as any)},
        {type:1,expr:'void => up, down => up',animation:[{type:6,styles:{transform:'translateY(100%)'},
            offset:(null as any)},{type:4,styles:{type:6,styles:{transform:'translateY(0)'},
            offset:(null as any)},timings:'0.1s ease-in'}],options:(null as any)},
        {type:1,expr:'up => void',animation:[{type:6,styles:{transform:'translateY(0)'},
            offset:(null as any)},{type:4,styles:{type:6,styles:{transform:'translateY(100%)'},
            offset:(null as any)},timings:'0.1s ease-in'}],options:(null as any)}],
        options:{}}]}});
function View_PopupComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(null as any),
      (null as any));
}
export function View_PopupComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),8,'div',[['class','k-popup']],[[24,'@toggle',0]],
      [[(null as any),'@toggle.done']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i1.PopupComponent = _v.component;
        if (('@toggle.done' === en)) {
          const pd_0:any = ((<any>_co.triggerOpen($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i2.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),(_l()(),i0.ɵted((null as any),['\n            '])),
      i0.ɵncd((null as any),0),(_l()(),i0.ɵted((null as any),['\n            '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_PopupComponent_1)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),i0.ɵdid(540672,(null as any),0,i2.NgTemplateOutlet,
          [i0.ViewContainerRef],{ngTemplateOutlet:[0,'ngTemplateOutlet']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵted((null as any),
          ['\n     ']))],(_ck,_v) => {
    var _co:i1.PopupComponent = _v.component;
    const currVal_1:any = 'k-popup';
    const currVal_2:any = _co.popupClass;
    _ck(_v,2,0,currVal_1,currVal_2);
    const currVal_3:any = _co.content;
    _ck(_v,7,0,currVal_3);
    const currVal_4:any = _co.content;
    _ck(_v,8,0,currVal_4);
  },(_ck,_v) => {
    var _co:i1.PopupComponent = _v.component;
    const currVal_0:any = _co.direction;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_PopupComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),6,'kendo-popup',
      ([] as any[]),(null as any),(null as any),(null as any),View_PopupComponent_0,
      RenderType_PopupComponent)),i0.ɵprd(512,(null as any),i3.DOMService,i3.DOMService,
      ([] as any[])),i0.ɵprd(512,(null as any),i4.AlignService,i4.AlignService,[i3.DOMService]),
      i0.ɵprd(512,(null as any),i5.PositionService,i5.PositionService,[i3.DOMService]),
      i0.ɵprd(512,(null as any),i6.ResizeService,i6.ResizeService,[i3.DOMService,i0.NgZone]),
      i0.ɵprd(512,(null as any),i7.ScrollableService,i7.ScrollableService,[i3.DOMService,
          i0.NgZone]),i0.ɵdid(13352960,(null as any),0,i1.PopupComponent,[i0.ElementRef,
          i4.AlignService,i3.DOMService,i0.ChangeDetectorRef,i5.PositionService,i6.ResizeService,
          i7.ScrollableService,i0.Renderer2,i0.NgZone],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,6,0);
      },(null as any));
}
export const PopupComponentNgFactory:i0.ComponentFactory<i1.PopupComponent> = i0.ɵccf('kendo-popup',
    i1.PopupComponent,View_PopupComponent_Host_0,{animate:'animate',anchor:'anchor',
        anchorAlign:'anchorAlign',collision:'collision',popupAlign:'popupAlign',copyAnchorStyles:'copyAnchorStyles',
        popupClass:'popupClass',positionMode:'positionMode',offset:'offset'},{anchorViewportLeave:'anchorViewportLeave',
        close:'close',open:'open'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9ub2RlX21vZHVsZXMvQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItcG9wdXAvZGlzdC9lcy9wb3B1cC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYzovUHJvamVjdHMvWXVEUklWL1NlcnZpY2VzQVBJL1l1RHJpdi1TZXJ2aWNlc0FQSS9FbmZvcmNlbWVudC9ub2RlX21vZHVsZXMvQHByb2dyZXNzL2tlbmRvLWFuZ3VsYXItcG9wdXAvZGlzdC9lcy9wb3B1cC5jb21wb25lbnQuZC50cyIsIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvbm9kZV9tb2R1bGVzL0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLXBvcHVwL2Rpc3QvZXMvcG9wdXAuY29tcG9uZW50LmQudHMuUG9wdXBDb21wb25lbnQuaHRtbCIsIm5nOi8vL2M6L1Byb2plY3RzL1l1RFJJVi9TZXJ2aWNlc0FQSS9ZdURyaXYtU2VydmljZXNBUEkvRW5mb3JjZW1lbnQvbm9kZV9tb2R1bGVzL0Bwcm9ncmVzcy9rZW5kby1hbmd1bGFyLXBvcHVwL2Rpc3QvZXMvcG9wdXAuY29tcG9uZW50LmQudHMuUG9wdXBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICAgICAgPGRpdiBjbGFzcz1cImstcG9wdXBcIiBbbmdDbGFzc109XCJwb3B1cENsYXNzXCIgW0B0b2dnbGVdPVwiZGlyZWN0aW9uXCIgKEB0b2dnbGUuZG9uZSk9XCJ0cmlnZ2VyT3BlbigkZXZlbnQpXCI+XG4gICAgICAgICAgICA8bmctY29udGVudD48L25nLWNvbnRlbnQ+XG4gICAgICAgICAgICA8bmctdGVtcGxhdGUgW25nVGVtcGxhdGVPdXRsZXRdPVwiY29udGVudFwiIFtuZ0lmXT1cImNvbnRlbnRcIj48L25nLXRlbXBsYXRlPlxuICAgICAgICA8L2Rpdj5cbiAgICAgIiwiPGtlbmRvLXBvcHVwPjwva2VuZG8tcG9wdXA+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQSwrQ0FDUTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQWtFO1VBQUE7VUFBQTtRQUFBO1FBQWxFO01BQUEsdUNBQUE7a0RBQUE7TUFBQSwyQkFBdUc7YUFDbkcsa0JBQXlCO01BQ3pCO2FBQUE7VUFBQSwrQkFBQTtVQUFBO01BQXlFLCtDQUN2RTtVQUFBOztJQUhEO0lBQWdCO0lBQXJCLFdBQUssVUFBZ0IsU0FBckI7SUFFOEM7SUFBMUMsV0FBMEMsU0FBMUM7SUFBYTtJQUFiLFdBQWEsU0FBYjs7O0lBRndDO0lBQTVDLFdBQTRDLFNBQTVDOzs7O29CQ0RSO01BQUE7K0JBQUE7TUFBQTthQUFBO2FBQUE7YUFBQTttQkFBQSxVQUFBOztxREFBQTs7UUFBQTs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/$$_gendir/~/@progress/kendo-angular-popup/dist/es/popup.component.ngfactory.ts